import {
  SlRange
} from "./chunk.6O7G7BNC.js";

// src/components/range/range.ts
var range_default = SlRange;
SlRange.define("sl-range");

export {
  range_default
};
